import { render } from "./BrandCard.vue?vue&type=template&id=cb4bb5b6&scoped=true"
import script from "./BrandCard.vue?vue&type=script&lang=js"
export * from "./BrandCard.vue?vue&type=script&lang=js"

import "./BrandCard.vue?vue&type=style&index=0&id=cb4bb5b6&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb4bb5b6"]])

export default __exports__